import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

interface EmptyStateMessageProps {
  className?: string;
  message?: string;
}

export const EmptyStateMessage: React.FC<EmptyStateMessageProps> = ({
  className,
  message,
}) => {
  const theme = useTheme();

  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 1.5,
        backgroundColor: theme.semantic.surfaceRaised,
        border: `1px solid ${theme.brandV2.colors.treadGray7}`,
        borderRadius: 2,
      }}
    >
      <InfoOutlined
        sx={{
          color: theme.brandV2.colors.treadBlack,
          fontSize: 24,
        }}
      />
      <Typography
        variant="body1"
        sx={{
          color: theme.brandV2.colors.treadBlack,
          fontWeight: 400,
          textAlign: 'center',
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};
